<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="scss">
body {
  margin: 0px !important;
  padding: 0px !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #323233;
  height: 100vh;
  overflow: auto;
  font-size: 14px;
  min-width: 1523px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue